<template>
  <b-alert v-if="hasSubscriptionsNotPayed" show variant="danger">
    <div class="row">
      <div class="col-md-10 mt-1">
        <i class="fas fa-info-circle mr-2" />
        <span>
          Existe {{ subscriptionsCount }} ({{ extensoText }}) boleto{{ plural }}
          a
          {{ `ser${subscriptionsCount >= 2 ? "em" : ""}` }}
          pago{{ plural }}, realize a quitação do{{ plural }} mesmo{{
            plural
          }}
          evitando o bloqueio do sistema.</span
        >
      </div>
      <div class="col mt-1 text-md-right">
        <b-btn
          size="sm"
          class="ml-5 mb-0 mt-0"
          href="/assinar"
          variant="success"
          >Ver boletos</b-btn
        >
      </div>
    </div>
  </b-alert>
</template>

<script>
import extenso from "extenso";

export default {
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    hasUser() {
      return this.user != null;
    },
    subscriptionsCount() {
      return this.hasUser
        ? this.$store.state.auth.user.subscriptions_not_payed
        : 0;
    },
    hasSubscriptionsNotPayed() {
      return this.subscriptionsCount > 0;
    },
    extensoText() {
      return extenso(this.subscriptionsCount, {
        mode: "number",
      });
    },
    plural() {
      return this.subscriptionsCount > 1 ? "s" : "";
    },
  },
};
</script>

<style>
</style>